import { render } from "./ComplexeUrgenceResume.vue?vue&type=template&id=3bc1c4e8"
import script from "./ComplexeUrgenceResume.vue?vue&type=script&lang=js"
export * from "./ComplexeUrgenceResume.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__